import { render, staticRenderFns } from "./EmployerClient.vue?vue&type=template&id=4883690d&"
import script from "./EmployerClient.vue?vue&type=script&lang=js&"
export * from "./EmployerClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports